import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  confirm(event) {
    event.preventDefault()

    const data = this.element.dataset
    const message = data.confirmMessage || "Êtes-vous sûr de vouloir supprimer ?"
    const form = this.element

    Swal.fire({
      title: data.confirmTitle || 'Supprimer ?',
      text: message,
      icon: data.confirmIcon || 'warning',
      showCancelButton: true,
      confirmButtonText: data.confirmButtonText || 'Oui, supprimer',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        form.submit()
      }
    })
  }
}
